import React, { useEffect } from "react";
import styles from "./Loader.module.css";
import { startLoading } from "./loadingTracker";

/**
 * Shown in the content area while a page's code is loading (App.js's
 * Suspense fallback). It also drives the top progress bar for as long as
 * it's on screen, so a slow page load shows progress in both places.
 */
export default function PageLoader({ label = "Loading" }) {
  useEffect(() => startLoading(), []);

  return (
    <div className={styles.pageLoader} role="status" aria-live="polite">
      <div className={styles.ring} aria-hidden="true">
        <span className={styles.ringTrack} />
        <span className={styles.ringArc} />
        <span className={styles.ringCore} />
      </div>
      <div className={styles.pageLoaderLabel}>
        {label}
        <span className={styles.dots} aria-hidden="true">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </div>
    </div>
  );
}
